import clsx, { ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Custom font-size keys declared in src/style/tailwind.css @theme block.
// Hard-coded here because TW4 config is CSS-based — no JS config to import from.
const fontSizeKeys = [
  'body-sm',
  'body-md',
  'body-lg',
  'label-sm',
  'label-md',
  'label-lg',
  'title-sm',
  'title-md',
  'title-lg',
  'headline-sm',
  'headline-md',
  'headline-lg',
  'display-sm',
  'display-md',
  'display-lg',
];

export const twMerge = extendTailwindMerge({
  classGroups: {
    'font-size': fontSizeKeys.map((key) => `text-${key}`),
  },
});

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
